/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type UserCell_user$ref: FragmentReference;
declare export opaque type UserCell_user$fragmentType: UserCell_user$ref;
export type UserCell_user = {|
  +id: string,
  +auth0Id: ?string,
  +fullName: ?string,
  +email: ?string,
  +membershipState: ?string,
  +birthdate: ?string,
  +gender: ?string,
  +phoneNumber: ?string,
  +createdAt: ?string,
  +fastCash: ?{|
    +id: string
  |},
  +$refType: UserCell_user$ref,
|};
export type UserCell_user$data = UserCell_user;
export type UserCell_user$key = {
  +$data?: UserCell_user$data,
  +$fragmentRefs: UserCell_user$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserCell_user",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "auth0Id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "membershipState",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "birthdate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gender",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FastCash",
      "kind": "LinkedField",
      "name": "fastCash",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "User"
};
})();
// prettier-ignore
(node/*: any*/).hash = '48e2542cfbc898afd375228d8685856a';

module.exports = node;
